/**
 * Indicador animado "Reading..." — los tres puntos aparecen en secuencia (uno,
 * luego otro, luego otro) en loop. La animación está en styles.css (.reading-dots).
 */
export function ReadingDots({ label = 'Reading' }: { label?: string }) {
  return (
    <span className="reading-dots" aria-live="polite">
      {label}
      <span className="reading-dot">.</span>
      <span className="reading-dot">.</span>
      <span className="reading-dot">.</span>
    </span>
  );
}
